export const dashboard = "/dashboard/admin-dashboard";
